<template>
    <div>
        <b-modal ref="AccGroupRef" id="AccGroupRef" :title="$t('Accounts group')" hide-footer size="lg">
        <b-form-group label-align="right" :label="$t('Group name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input  type="text" v-model="AccGroup.group_name"/>
        </b-form-group>

        <b-form-group label-align="right">
        <md-button v-b-toggle="'accs'"  @click="accsClicked" style="margin-left: 4rem;" class="md-raised">{{ $t('Accounts') }}</md-button>
        <b-collapse id="accs" target="actionsID" triggers="click" placement="right">
            <b-card class="mb-1">
              <accounts @AccountSelected="AccountSelected" ></accounts>
            </b-card>
        </b-collapse>
        </b-form-group>

        <basic-table
            v-if="AccountsInGroup"
            :items="AccountsInGroup"
            :fields="AccountsInGroupFields"
            :filter="filter"
            :perPage="perPageAccs"
            :currentPage="currentPageAccs"
            @ClickOnDeleteButton="clickOnDeleteAccountsInGroup"
            isDelete="true"/>
            <table-manager-bottom
              :totalRows="totalRows"
              :perPage="perPageAccs" v-model="currentPageAccs"/>
        <modal-ok-cancel @save="saveGroup" @cancel="$bvModal.hide('AccGroupRef')" size="md"/>
    </b-modal>
    </div>
</template>

<script>
import accounts from './accounts.vue'
export default {
  components: {
    accounts
  },
  props: {
    AccGroup: null,
    isEdit: false
  },
  data () {
    return {
      totalRows: 0,
      filter: '',
      perPageAccs: 25,
      AccsToAdd: {group_id: 0, accounts: []},
      currentPageAccs: 1,
      AccountsInGroup: [],
      AccountsToLinked: [],
      AccountsToUnlink: [],

      isNeedLinkAccs: false,
      isNeedUnlinkAccs: false,
      isNameEdited: false,
      AccountsInGroupFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],

      selectedAccountsGroups: null
    }
  },
  watch: {
    AccGroup: {
      deep: true,
      handler: function (newVal, oldVal) {
        if (oldVal.group_name !== newVal.group_name) {
          this.isNameEdited = true
        }
      }
    }
  },
  methods: {
    saveGroup () {
      if (this.AccGroup.group_name.length === 0) {
        this.$root.$emit('makeToasts', 'danger', 'Group name is empty', 'Error')
        return
      }
      if (!this.isEdit) {
        this.$store.dispatch('Users/CREATE_ACCOUNTS_GROUPS', this.AccGroup)
      }
      if (this.isNeedUnlinkAccs) {
        let body = {group_id: this.AccGroup.group_id, accounts: this.AccountsToUnlink}
        this.$store.dispatch('Users/UNLINK_ACCOUNTS_FROM_GROUP', body)
      }
      if (this.isNeedLinkAccs) {
        let body = {group_id: this.AccGroup.group_id, accounts: this.AccountsToLinked}
        this.$store.dispatch('Users/ADD_ACCOUNTS_TO_GROUPS', body)
      }
      if (this.isNameEdited) {
        let body = {group_id: this.AccGroup.group_id, group_name: this.AccGroup.group_name}
        this.$store.dispatch('Users/UPD_ACCOUNTS_GROUPS', body)
      }

      setTimeout(this.$store.dispatch, 500, 'Users/GET_ACCOUNTS_GROUPS')
      this.$refs.AccGroupRef.hide()
    },
    accsClicked () {
      this.$store.dispatch('Users/GET_ACCOUNTS_LIST', {
        currentPage: 1,
        perPage: 35,
        filter: '',
        sortField: '',
        isDesc: 0
      })
    },
    clickOnDeleteAccountsInGroup (item) {
      if (this.isEdit) {
        this.AccountsToUnlink = this.AccountsToUnlink.filter(accID => {
          return accID !== item.account_id
        })
        this.AccountsToUnlink.push(item.account_id)
        this.isNeedUnlinkAccs = true
      }
      this.AccountsInGroup = this.AccountsInGroup.filter(el => {
        return el.account_id !== item.account_id
      })
      this.AccGroup.accounts = this.AccGroup.accounts.filter(acc => {
        return acc !== item.account_id
      })
      this.totalRows = this.AccountsInGroup.length
    },
    ClearAccounts () {
      this.AccountsInGroup = []
      this.AccountsToLinked = []
      this.AccountsToUnlink = []
      this.isNameEdited = false
      this.isNeedLinkAccs = false
      this.isNeedUnlinkAccs = false
      this.totalRows = 0
    },
    SetAccounts (accs) {
      this.AccountsInGroup = []
      this.AccountsToLinked = []
      this.AccountsToUnlink = []
      this.isNameEdited = false
      this.isNeedLinkAccs = false
      this.isNeedUnlinkAccs = false
      accs.forEach(element => {
        this.AccountsInGroup.push({account_id: element})
      })
      this.totalRows = this.AccountsInGroup.length
    },
    AccountSelected (item) {
      if (this.isEdit) {
        this.AccountsToLinked = this.AccountsToLinked.filter(accID => {
          return accID !== item.account_id
        })
        this.AccountsToLinked.push(item.account_id)
        this.isNeedLinkAccs = true
      }
      this.AccountsInGroup = this.AccountsInGroup.filter(el => {
        return el.account_id !== item.account_id
      })
      this.AccountsInGroup.push({account_id: item.account_id})

      this.AccGroup.accounts = this.AccGroup.accounts.filter(accID => {
        return accID !== item.account_id
      })
      this.AccGroup.accounts.push(item.account_id)
      this.totalRows = this.AccountsInGroup.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/accountsGroups/editModal.vue